import { takeLatest, put, all, call } from "redux-saga/effects";
import { FETCH_RRD_INFO } from "@reducers/actionTypes";

import { actions } from "@reducers/rrdReducer";
import {
  getDeliveriesOverview,
  getDeliveryReturn,
  getRefunds,
} from "@services/api";

function* fetchRRDData() {
  try {
    const overviewData = yield call(getDeliveriesOverview);
    const deliveryReturnData = yield call(getDeliveryReturn);
    const refundsData = yield call(getRefunds);
    yield put(
      actions.setRRDInfo({
        overviewData: overviewData?.data,
        deliveryReturnData: deliveryReturnData?.data,
        refundsData: refundsData?.data,
      }),
    );
  } catch (e) {}
}

export default function* rrdSaga() {
  yield all([takeLatest(FETCH_RRD_INFO, fetchRRDData)]);
}
